import React from 'react';
import { Box, Button, MenuItem, TextField } from '@mui/material';
import { ColorPalette } from '../config';
import { getCalendarViewDisplay, getHeaderTitle } from './calendar-helpers';
import { CalendarView } from './calendar-types';
import { ICalendarToolbarProps } from './calendar-toolbar-types';

const selectableCalendarViews: CalendarView[] = ['day', 'week', 'month', 'threeMonths', 'year', 'agenda'];

const outlinedGroup = { border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: 1, overflow: 'hidden', display: 'flex' };

const groupButton = { minWidth: 0, px: 1.2, textTransform: 'none', borderRadius: 0 };

export function CalendarToolbarCompact(props: ICalendarToolbarProps) {
  const { firstDate, onNextClick, onPreviousClick, onCalendarViewChange, currentCalendarView, onTodayClick, onAddEventClick } = props;

  function handleViewChange(event: React.ChangeEvent<HTMLInputElement>) {
    onCalendarViewChange(event.target.value as CalendarView);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        padding: '10px',
        backgroundColor: ColorPalette.LightHeaderBackground,
        borderRadius: '3px 3px 0 0',
        border: 'solid 1px rgba(0, 0, 0, 0.15)',
        borderBottom: 'none',
      }}
    >
      {currentCalendarView !== 'agenda' && (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Box sx={outlinedGroup}>
            <Button size="small" color="inherit" aria-label="Forrige" onClick={onPreviousClick} sx={{ ...groupButton, px: 1.4, fontSize: '1.15rem', lineHeight: 1 }}>
              ‹
            </Button>
            <Button
              size="small"
              color="inherit"
              aria-label="Næste"
              onClick={onNextClick}
              sx={{ ...groupButton, px: 1.4, fontSize: '1.15rem', lineHeight: 1, borderLeft: '1px solid rgba(0, 0, 0, 0.12)' }}
            >
              ›
            </Button>
          </Box>
          <Box sx={outlinedGroup}>
            <Button size="small" color="inherit" onClick={onTodayClick} sx={groupButton}>
              I dag
            </Button>
          </Box>
          {onAddEventClick && (
            <Box sx={outlinedGroup}>
              <Button size="small" variant="contained" onClick={onAddEventClick} sx={groupButton}>
                Tilføj begivenhed
              </Button>
            </Box>
          )}
        </Box>
      )}
      <Box sx={{ flex: '1 1 auto', minWidth: 120, fontFamily: 'Roboto', fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
        {getHeaderTitle(currentCalendarView, firstDate)}
      </Box>
      <TextField
        select
        size="small"
        aria-label="Visning"
        value={currentCalendarView}
        onChange={handleViewChange}
        sx={{ minWidth: 130, bgcolor: 'common.white', '& .MuiSelect-select': { py: 0.5, fontSize: '14px' } }}
      >
        {selectableCalendarViews.map(view => (
          <MenuItem key={view} value={view}>
            {getCalendarViewDisplay(view)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
